import React from "react";
import { TableRow, TableCell } from '@mui/material'
import AssociatedLinkedWrappers from '../associated_linked_wrappers';
import List from '../../shared/Table/components/List'

function AssociatedLinkedBenefits (props) {
  const headers = [
    { key: 'linkName', label: 'Link Name' },
    { key: 'linkedBenefits', label: 'Linked Leave Benefits' },
    { key: 'scenarios', label: 'Scenarios' },
    { key: 'maxDuration', label: 'Shared Max Duration' },
    { key: 'updated', label: 'Link Updated' }
  ];

  const processData = (rows, styles) => {
    return (
      <>
        {rows.map((row, index) => {
          const date = moment(row.updated_at).tz('America/Los_Angeles')
          const scenarios = row.scenarios || []
          return (
            <TableRow key={index} sx={index % 2 === 0 ? styles.rowGrey : {}}>
              <TableCell sx={styles.cell} component="th" scope="row">
                <a href={`/admin/linked_benefits/${row.id}/edit`}>
                  <u style={styles.content}>
                    {row.name}
                  </u>
                </a>
              </TableCell>

              <TableCell key={index} sx={styles.cell} component="th" scope="row">
                <ul style={styles.list}>
                  {(row.benefits || []).filter(benefit => benefit != null).map((benefit, index) => {
                    return (
                      <li style={styles.content}>
                        {benefit.includes(props.id) ? <b>{benefit}</b> : <>{benefit}</>}
                      </li>
                    )
                  })}
                </ul>
              </TableCell>

              <TableCell key={index} sx={styles.cell} component="th" scope="row">
                <List data={scenarios} avoidWordify={true} />
              </TableCell>

              <TableCell key={index} sx={styles.cell} component="th" scope="row">
                <ul style={styles.list}>
                  {(row.wrapper_scenarios || []).filter(wrapper_scenario => wrapper_scenario != null).map((wrapper_scenario, index) => {
                    return (
                      <li style={styles.content}>
                        {wrapper_scenario}
                      </li>
                    )
                  })}
                </ul>
              </TableCell>
              <TableCell sx={styles.cell}> {date.format("MM/DD/YYYY, hh:mm A")}</TableCell>
            </TableRow>
          )
        })}
      </>
    )
  };

  return (
    <div style={{ marginTop: 40 }}>
      <AssociatedLinkedWrappers
        emptyMessage="Benefit is not linked to any other Leave Benefit"
        fetchUrl={props.fetch_url}
        headers={headers}
        processData={processData}
      />
    </div>
  );
}

export default AssociatedLinkedBenefits;
